module.exports = __webpack_public_path__ + "static/media/plate2-img1.0d9ca345.png";